export default "/_next/static/fonts/tt_norms_pro_bold_italic-2bc78e95fdff816ef18d38e7ca40e347.woff";